import auth from '../../../utils/auth';
import {
  notificationTypes,
  notificationTypeValue,
  notificationJobOptions,
  notificationJobsValue,
} from '../../../utils/NotificationEnums';
import { appStatusType } from '../../../utils/enums';

export function getNotificationTypeOptions(type, hasReferenceCompletedNotification) {
  let typeOptions = notificationTypes();

  if (auth.isDistrictUserOnly()) {
    typeOptions = typeOptions.filter(districtUserTypeOptions);
  }
  if (auth.isDistrictAdmin() && !auth.isSuperAdminUser()) {
    typeOptions = typeOptions.filter(districtAdminTypeOptions);
  }
  if (auth.isSchoolAdmin()) {
    typeOptions = typeOptions.filter(schoolAdminTypeOptions);
  }

  if (auth.isSuperAdminUser() && auth.isAtsLiteDistrict()) {
    typeOptions = typeOptions.filter(atsLiteSuperAdminTypeOptions);
  }

  if (auth.isSuperAdminUser() && auth.isATSFullDistrict()) {
    typeOptions = typeOptions.filter(atsFullSuperAdminTypeOptions);
  }

  if (!auth.hasConnectIntegrationModule()) {
    typeOptions = typeOptions.filter(nonConnectHiringRequest);
  }

  // According to spec the user may only have at most one reference completed notification.
  // If they already have one, don't show that notification type in the modal dropdown
  // unless they are currently editing that notification.
  if (type !== notificationTypeValue.reference_completed && hasReferenceCompletedNotification) {
    typeOptions = typeOptions.filter(nonReferenceCompleted);
  }
  return typeOptions;
}

function districtUserTypeOptions(option) {
  return (
    option.value !== notificationTypeValue.job_request &&
    option.value !== notificationTypeValue.new_vacancy &&
    option.value !== notificationTypeValue.candidate_auto_screened &&
    option.value !== notificationTypeValue.candidate_selected_for_hire &&
    option.value !== notificationTypeValue.connect_hiring_request_submitted
  );
}

function districtAdminTypeOptions(option) {
  return (
    option.value !== notificationTypeValue.candidate_auto_screened &&
    option.value !== notificationTypeValue.candidate_selected_for_hire &&
    option.value !== notificationTypeValue.connect_hiring_request_submitted
  );
}

function schoolAdminTypeOptions(option) {
  return (
    option.value !== notificationTypeValue.job_request &&
    option.value !== notificationTypeValue.new_applicant &&
    option.value !== notificationTypeValue.new_vacancy &&
    option.value !== notificationTypeValue.candidate_auto_screened &&
    option.value !== notificationTypeValue.candidate_selected_for_hire &&
    option.value !== notificationTypeValue.connect_hiring_request_submitted
  );
}

function atsLiteSuperAdminTypeOptions(option) {
  return (
    option.value !== notificationTypeValue.job_request &&
    option.value !== notificationTypeValue.new_job_posted &&
    option.value !== notificationTypeValue.new_vacancy &&
    option.value !== notificationTypeValue.candidate_auto_screened
  );
}

function atsFullSuperAdminTypeOptions(option) {
  return option.value !== notificationTypeValue.candidate_selected_for_hire;
}

function nonConnectHiringRequest(option) {
  return option.value !== notificationTypeValue.connect_hiring_request_submitted;
}

function nonReferenceCompleted(option) {
  return option.value !== notificationTypeValue.reference_completed;
}

export function formatCategoryOptions(categories) {
  return categories.map((category) => ({
    value: category.id,
    ...category,
  }));
}

export function formatSchoolOptions(schools) {
  return schools.map((school) => ({
    label: school.name,
    value: school.id,
    ...school,
  }));
}

export function statusVisibleToSchoolAdmin(status) {
  return status.school_admin_view_access === true;
}

export function statusIsNotDraft(status) {
  return status.status_type !== appStatusType.draft;
}

export function noStatusSelected(status_id) {
  return status_id === null;
}

export function filterStatusOptions(statuses) {
  statuses = statuses.filter(statusIsNotDraft);
  if (auth.isSchoolAdmin()) {
    statuses = statuses.filter(statusVisibleToSchoolAdmin);
  }
  return statuses;
}

export function getStatusOptions(statuses) {
  statuses = filterStatusOptions(statuses);

  return statuses.map((status) => ({
    value: status.id,
    label: status.label,
    ...status,
  }));
}

export function getInitialCategories(notification) {
  return notification.job_categories.map((category) => ({
    value: category.id,
    ...category,
  }));
}

export function getInitialSchools(notification) {
  return notification.schools.map((school) => ({
    label: school.name,
    value: school.id,
    ...school,
  }));
}

export const showJobsDropdown = (type) => {
  if (!auth.isDistrictAdmin()) return false;
  return [
    notificationTypeValue.status_change,
    notificationTypeValue.new_applicant,
    notificationTypeValue.new_vacancy,
    notificationTypeValue.candidate_auto_screened,
    notificationTypeValue.candidate_selected_for_hire,
    notificationTypeValue.connect_hiring_request_submitted,
  ].includes(type);
};

const notificationTypesToShowSchoolsDropdown = [
  notificationTypeValue.status_change,
  notificationTypeValue.candidate_auto_screened,
  notificationTypeValue.candidate_selected_for_hire,
  notificationTypeValue.connect_hiring_request_submitted,
];

export const showSchoolsDropdown = (type) =>
  auth.isDistrictAdmin() && notificationTypesToShowSchoolsDropdown.includes(type);

export function frequencyDropdownDisabled(value) {
  return value === notificationTypeValue.new_top_candidate;
}

export function getNotificationJobOptions() {
  let jobOptions = notificationJobOptions();

  if (auth.isSuperAdminUser() && auth.isAtsLiteDistrict()) {
    jobOptions = jobOptions.filter((option) => option.value !== notificationJobsValue.owned_jobs);
  }

  return jobOptions;
}
